<template>
  <div>
    <Dialog
      :visible.sync="showCalendar1"
      :style="{ width: '1300px', overflowY: 'auto' }"
      header="Calendar"
      :modal="true"
      class="p-fluid"
      :maximizable="true"
    >
      <div class="row" style="min-height: 500px;">
        <div class="col col-lg-2 col-md-3">
          <Listbox
            v-model="selectedUser"
            :options="users"
            optionLabel="user"
            dataKey="id"
            style="width:15rem; height: 100%;"
          />
        </div>
        <div class="col col-lg-10 col-md-9">
          <FullCalendar
            :key="calendarKey"
            :events="this.selectedUser.activities"
            :options="options"
          />
        </div>
      </div>

      <br />
      <br />
      <br />

      <!-- <template #footer>
      </template> -->
    </Dialog>
  </div>
</template>

<script>
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";

export default {
  props: {
    showCalendar: {
      type: Boolean,
      required: true
    },
    activities: {
      type: Array,
      requried: false
    }
  },
  data: () => ({
    options: {
      plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
      initialDate: "2019-01-01",
      headerToolbar: {
        left: "prev,next",
        center: "title",
        right: "dayGridMonth,timeGridWeek,timeGridDay"
      },
      editable: false
    },
    smallestYear: new Date().getFullYear(),
    smallestMonth: 12,
    users: [],
    selectedUser: {},
    calendarKey: 0
  }),
  computed: {
    showCalendar1: {
      set(val) {
        if (!val) {
          this.$emit("close");
        }
      },
      get() {
        return this.showCalendar;
      }
    }
  },
  created() {
    this.setupComponent();
  },
  watch: {
    users(val) {
      this.setSelectedUser();
    },
    calendarKey(val) {},
    showCalendar(val) {
      this.setSelectedUser();
    },
    smallestMonth(val) {
      this.options.initialDate = `${this.smallestYear}-${this.smallestMonth}-01`;

      this.calendarKey++;
    },
    smallestYear(val) {
      this.options.initialDate = `${this.smallestYear}-${this.smallestMonth}-01`;

      this.calendarKey++;
    },
    selectedUser(val) {
      this.resetDates();

      if (val.activities) {
      }
      val.activities.forEach(activity => {
        //
        let a = activity.start.split("-");
        //
        this.setDate(a);
      });
    },
    activities(val) {
      this.setupComponent();
    }
  },
  methods: {
    setSelectedUser() {
      if (this.showCalendar && this.users && this.users[0]) {
        this.selectedUser = this.users[0];
      }
    },
    resetDates() {
      this.smallestYear = new Date().getFullYear();
      this.smallestMonth = 12;
    },
    setDate(arr) {
      if (parseInt(arr[0]) < this.smallestYear) {
        this.smallestYear = parseInt(arr[0]);
      }
      if (
        parseInt(arr[0]) <= this.smallestYear &&
        parseInt(arr[1]) < this.smallestMonth
      ) {
        this.smallestMonth = parseInt(arr[1]);
      }
    },
    formatDate(date) {
      let a = date.split("/");
      return `${a[2]}-${a[1]}-${a[0]}`;
    },
    setupComponent() {
      this.setupUsers();
    },
    setupUsers() {
      if (this.activities) {
        for (let i = 0; i < this.activities.length; i++) {
          //
          if (
            this.activities[i] &&
            this.activities[i].user &&
            this.activities[i].subject &&
            this.activities[i].startDate &&
            this.activities[i].endDate
          ) {
            let activity = {
              id: i,
              activity: this.activities[i],
              title: this.activities[i].subject,
              start: this.formatDate(this.activities[i].startDate),
              end: this.formatDate(this.activities[i].startDate)
            };

            let userIndex = this.users.findIndex(
              a => a && a.user === this.activities[i].user.fullName
            );
            //

            if (userIndex < 0) {
              let user = {
                id: i,
                user: this.activities[i].user.fullName,
                activities: [activity]
              };
              this.users.push(user);
            } else {
              this.users[userIndex].activities.push(activity);
            }
          }
        }
      }
    }
  }
};
</script>

<style></style>
